import { render, staticRenderFns } from "./WsAccredCompsDocumentsItem.vue?vue&type=template&id=538050bc"
import script from "./WsAccredCompsDocumentsItem.vue?vue&type=script&lang=js"
export * from "./WsAccredCompsDocumentsItem.vue?vue&type=script&lang=js"
import style0 from "./WsAccredCompsDocumentsItem.vue?vue&type=style&index=0&id=538050bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports